import { render } from "./ViewPlaylistComp.vue?vue&type=template&id=8f3b7568&scoped=true"
import script from "./ViewPlaylistComp.vue?vue&type=script&lang=js"
export * from "./ViewPlaylistComp.vue?vue&type=script&lang=js"

import "./ViewPlaylistComp.vue?vue&type=style&index=0&id=8f3b7568&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f3b7568"]])

export default __exports__